import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "../mock";

const ParallaxBanner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1]);

  return (
    <section ref={ref} className="relative h-[70vh] min-h-[440px] overflow-hidden flex items-center justify-center">
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <video
          className="w-full h-full object-cover"
          src="/videos/banner-drive.mp4"
          autoPlay
          muted
          loop
          playsInline
          poster={IMAGES.redBmwRoad}
        />
        <div className="absolute inset-0 bg-[#08080a]/60" />
      </motion.div>

      <div className="relative z-10 text-center px-5 max-w-3xl">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="section-title text-4xl md:text-6xl text-white"
        >
          Chaque kilomètre <br /> raconte une <span className="racing-text">passion</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.7 }}
          className="mt-6 text-white/70 text-lg max-w-xl mx-auto"
        >
          Je mets mon expertise au service de votre rêve automobile, pour une
          acquisition sereine et optimisée.
        </motion.p>
      </div>
    </section>
  );
};

export default ParallaxBanner;
